document.addEventListener('click', function (event) {
 const toggle = event.target.closest('.photo-toggle');
 if (toggle) {
  const card = toggle.closest('[data-photo-card]');
  const showingBack = card.classList.toggle('show-back');
  toggle.setAttribute('aria-pressed', String(showingBack));
  toggle.textContent = showingBack ? 'View the front ↻' : 'View the back ↻';
  toggle.setAttribute('aria-label', showingBack ? 'Show front view of tee' : 'Show back view of tee');
 }
 const menuLink = event.target.closest('.mobile-menu a');
 if (menuLink) menuLink.closest('details').open = false;
});
document.addEventListener('keydown', function (event) {
 if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(function(menu) { menu.open = false; menu.querySelector('summary').focus(); });
});
document.addEventListener('change', function(event) {
 const select = event.target.closest('[data-variant-select]');
 if (!select) return;
 const option = select.selectedOptions[0];
 const product = select.closest('[data-product]');
 const button = product.querySelector('[data-add-button]');
 const price = product.querySelector('[data-product-price]');
 if (price) price.textContent = option.dataset.price;
 if (button) { const available = option.dataset.available === 'true' && option.dataset.priced === 'true'; button.disabled = !available; button.textContent = available ? (button.dataset.purchaseLabel || 'Add to bag') : 'Sold out'; }
 const url = new URL(window.location.href); url.searchParams.set('variant', select.value); window.history.replaceState({}, '', url);
});

document.addEventListener('click', function(event) {
 const link = event.target.closest('[data-photo-zoom]');
 if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
 const dialog = document.createElement('dialog');
 if (typeof dialog.showModal !== 'function') return;
 event.preventDefault();
 dialog.className = 'photo-dialog';
 const close = document.createElement('button');
 close.type = 'button'; close.className = 'photo-dialog-close';
 close.textContent = 'Close ×'; close.setAttribute('aria-label', 'Close photo preview');
 const img = document.createElement('img');
 const card = link.closest('[data-photo-card]');
 const source = card ? card.querySelector(card.classList.contains('show-back') ? '.back-photo' : '.front-photo') : link.querySelector('img');
 img.src = card && source ? source.src : link.href;
 img.alt = source ? source.alt : link.textContent.trim();
 dialog.setAttribute('aria-label', img.alt || 'Product photo');
 dialog.append(close, img); document.body.appendChild(dialog);
 close.addEventListener('click', function() { dialog.close(); });
 dialog.addEventListener('click', function(e) { if (e.target === dialog) dialog.close(); });
 dialog.addEventListener('close', function() { dialog.remove(); link.focus(); }, {once:true});
 dialog.showModal(); close.focus();
});
